module.exports = __webpack_public_path__ + "img/appAsset--groups-ax.315a8df7.svg";